// @core/api/endpoints/subscription/list_add_ons.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAddOnsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List addons
 * Returns available addons with optional filtering by plan compatibility and type.
 * @public This endpoint does not require authentication
 */
export async function ListAddOns(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAddOnsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/addons`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListAddOnsResponse>(requestPath, { ...requestOptions, params });
}
